// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__duGlP","inner":"header_inner__4yWlr","logo":"header_logo__cejB8"};